import { call } from '../core'

export function requestRefreshAuth() {
  call('finRequestRefreshAuth')
}
